import axios from 'axios';
import cookie from 'vue-cookie';

/**
 *
 * @param {object} blob 二进制文件流
 * @param {String} filename 文件名称
 */
const exportFile = (blob, filename) => {
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE
        window.navigator.msSaveOrOpenBlob(blob, filename)
    } else {
        const URL = window.URL || window.webkitURL
        const downloadUrl = URL.createObjectURL(blob)

        if (filename) {
            // use HTML5 a[download] attribute to specify filename
            const a = document.createElement('a')
            // safari doesn't support this yet
            if (typeof a.download === 'undefined') {
                window.location = downloadUrl
            } else {
                let DOMA = a;
                a.href = downloadUrl
                a.target = '_blank'
                a.download = filename
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(DOMA)
            }
        } else {
            window.location = downloadUrl
        }
        setTimeout(() => {
            URL.revokeObjectURL(downloadUrl)
        }, 100)
    }
}

const exportFileByPost = (url, params, filename, responseType = 'blob') => {
    // 发起 POST 请求（请求体传参）
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json', // 表明请求体是 JSON 格式
            // 如需 Token 认证，添加 Authorization 头（根据项目实际情况调整）
            // 'Authorization': `Bearer ${localStorage.getItem('token')}`
            'client-id': '2ef739e2-4593-4108-bbf6-b869ee66bbe7',
            'token': cookie.get('token')
        },
        body: JSON.stringify(params), // 将参数转为 JSON 字符串（请求体核心）
        responseType, // 指定响应类型为 Blob（文件流）
    })
    .then(response => {
        // 校验响应状态
        if (!response.ok) {
            return Promise.reject(`请求失败：${response.status} ${response.statusText}`);
        }
        // 将响应转为 Blob 对象（文件流）
        return response.blob();
    })
    .then(blob => {
        // 调用下载工具函数，触发文件下载
        exportFile(blob, filename);
    })
    .catch(error  => {
        return error;
        // 可添加错误提示（如 Element UI 的 Message 组件）
        // Message.error('文件导出失败，请重试！');
    });
};


// 添加命名导出（关键：让 Vue 组件能引入这个函数）
export { exportFileByPost };

/**
* 导出文件
* @param {Object} file [description]
* @param {string} file.fileUrl 文件路劲
* @param {string} file.fileName 文件名称
* @return {[type]}      [description]
*/
export default function (file) {
    return axios.get(file && file.fileUrl, {
        headers: {
            'client-id': '2ef739e2-4593-4108-bbf6-b869ee66bbe7',
            'token': cookie.get('token'),
        },
        responseType: 'blob'
    }).then(res => {
        exportFile(res && res.data, file.fileName)
        return res
    })
}
